export default __webpack_public_path__ + "static/c-d8326b824f14cceebb2fc69d3c1257c1.png";